import { useSelector } from 'react-redux';
import {jwtDecode} from 'jwt-decode';
import { use } from 'react';

// Selectors
export const isAuthenticatedSelector = (state) => state.auth.isAuthenticated;
export const tokenSelector = (state) => state.auth.accessToken;
export const refreshTokenSelector = (state) => state.auth.refreshToken;
export const rolesSelector = (state) => state.auth.roles;
export const profileImage = (state) => state.auth.profileImage;
export const doctorIdSelector = (state) => state.auth.doctorId;
export const idSelector = (state) => state.auth.id;
export const requestApiTokenSelector=(state) => state.auth.requestApiToken
export const nameSelector = (state) => state.auth.name;
export const clinicLogoSelector = (state) => state.auth.clinicLogo;
export const clinicIdSelector = (state) => state.auth.clinicId;

// Custom hooks



export function useToken() {
  return useSelector(tokenSelector) || null;
}

export function useRefreshToken() {
  return useSelector(refreshTokenSelector) || null;
}
export function useRequestApiToken() {
  return useSelector(requestApiTokenSelector) || null;
}








// Selectors
export const isVerifiedSelector = (state) => state.verification.isVerified;
export const userSelector = (state) => state.verification.user;



// Custom hooks
export function useIsVerified() {
  return useSelector(isVerifiedSelector);
}

export function useUser() {
  const user = {
    id: useSelector(idSelector),
    clinicId: useSelector(clinicIdSelector),
    doctorId: useSelector(doctorIdSelector),
    roles: useSelector(rolesSelector),
    profileImage: useSelector(profileImage),
    clinicLogo: useSelector(clinicLogoSelector),
    name: useSelector(nameSelector),
  };
  return user || null;
}

export function useUserRoles() {

  return useSelector(rolesSelector) || null;
}

export function useDoctorId() {
  const user = useUser();
  return user?.doctorId || null;
}


export function usePermissions() {
  const roles = useUserRoles();
const fullAccessRoles = [
  "owner", // clinic owner
  "admin", // clinic manager
  "subadmin", // limited admin
];
  const roleList = Array.isArray(roles)
    ? roles
    : typeof roles === "string"
      ? [roles]
      : roles?.role
        ? [roles.role]
        : Array.isArray(roles?.roles)
          ? roles.roles
          : [];

  if (roleList.some((role) => fullAccessRoles.includes(role))) {
    return { permissions: "full", loadingPermissions: false };
  }
 

  const reduxPermissions = useSelector(
    (state) => state.permissions?.permissions
  );

  const loadingPermissions = useSelector(
    (state) => state.permissions?.loading ?? false
  );

  const localPermissions = (() => {
    try {
      const stored = localStorage.getItem("userPermissions");
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  })();

  const permissions = reduxPermissions ?? localPermissions;

  return { permissions, loadingPermissions };
}


// Hook (kept name for compatibility)
export function useIsAuthenticated() {
  // Returns true if verified, false otherwise
  return !!useSelector(isAuthenticatedSelector);
}

